(function () {
  var popup = null;
  var slidesContainer = null;
  var atcBtn = null;
  var popupTitle = null;
  var atcToast = null;
  var variantStrip = null;
  var shareTitle = '';
  var atcToastTimer = null;
  var popupIndex = 0;
  var popupVideos = [];
  var isMuted = false;
  var touchStartY = 0;
  var touchDeltaY = 0;
  var isSwiping = false;
  var activeContext = null;
  var initialized = false;
  var desktopMq = window.matchMedia('(min-width: 768px)');
  var isScrollFeedMode = false;
  var scrollFeedRaf = null;
  var scrollFeedBound = false;
  var reelProductKeys = [];
  var activeProductKey = null;
  var popupDetails = null;

  function isDesktop() {
    return desktopMq && desktopMq.matches;
  }

  function scrollSelectedReelVariantIntoView(stripRoot) {
    if (!stripRoot) return;
    var picker = stripRoot.querySelector('.reel-variant-picker');
    if (!picker) return;
    var scrollEl = picker.querySelector('.reel-variant-picker__scroll');
    var selected = picker.querySelector('.reel-v-wrap.is-selected');
    if (!scrollEl || !selected) return;
    var padding = 16;
    var containerRect = scrollEl.getBoundingClientRect();
    var itemRect = selected.getBoundingClientRect();
    if (itemRect.left < containerRect.left + padding) {
      scrollEl.scrollLeft -= containerRect.left + padding - itemRect.left;
    } else if (itemRect.right > containerRect.right - padding) {
      scrollEl.scrollLeft += itemRect.right - containerRect.right + padding;
    }
  }

  window.scrollSelectedReelVariantIntoView = scrollSelectedReelVariantIntoView;

  function syncReelPopupAtcFromVariant() {
    if (!atcBtn || !variantStrip) return;
    var stripRoot = variantStrip.querySelector('.reel-variant-picker');
    if (!stripRoot) return;
    var selected = stripRoot.querySelector('.reel-v-wrap.is-selected button.reel-v-btn');
    var btn = selected || stripRoot.querySelector('button.reel-v-btn');
    if (!btn) return;
    var vid = btn.getAttribute('data-variant-id');
    var price = btn.getAttribute('data-variant-price');
    var selectedProductTitle = btn.getAttribute('data-product-title');
    if (vid) atcBtn.setAttribute('data-selected-variant-id', vid);
    if (price) {
      var priceEl = atcBtn.querySelector('.creator-reels__popup-atc-price');
      if (priceEl) priceEl.textContent = price;
    }
    if (popupTitle) {
      popupTitle.textContent =
        (selectedProductTitle && selectedProductTitle.trim()) ||
        popupTitle.getAttribute('data-default-title') ||
        popupTitle.textContent;
    }
  }

  function syncPageProductFormVariantId(variantId) {
    if (variantId == null || variantId === '') return;
    var idStr = String(variantId);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      idInput.removeAttribute('disabled');
      idInput.value = idStr;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
    document.dispatchEvent(
      new CustomEvent('reel-popup:variant-selected', {
        bubbles: true,
        detail: { variantId: parseInt(idStr, 10) },
      })
    );
  }

  function syncMobileCartToolbarUI(itemCount) {
    var count = itemCount != null ? itemCount : 0;
    var hasItems = count > 0;
    document.querySelectorAll('.hdt-section-toolbar-mobile-cart').forEach(function (cartEl) {
      // cartEl.classList.toggle('hdt-cart-count-many', hasItems);
      // cartEl.classList.toggle('hdt-cart-count-one', count === 1);
      // Blink fill (green then blue) is owned by Shopify.cartBtnAnimation.
      // Setting those classes here cancels the sequence on PDP, where this
      // popup listens to every cart:change and the sticky cart is the only icon.
      var activeIcon = cartEl.querySelector('.cart-active-state-icon');
      var normalIcon = cartEl.querySelector('.cart-normal-state-icon');
      var countEl = cartEl.querySelector('hdt-cart-count');
      if (activeIcon) {
        activeIcon.classList.toggle('show-active-icon', hasItems);
        activeIcon.classList.toggle('hide-active-icon', !hasItems);
      }
      if (normalIcon) {
        normalIcon.classList.toggle('hide-active-icon', hasItems);
        normalIcon.classList.toggle('show-active-icon', !hasItems);
      }
      if (countEl) {
        countEl.classList.toggle('hide-cart-counter', !hasItems);
        countEl.textContent = count;
      }
    });
  }

  function showAtcToast(message, isError) {
    if (!atcToast) return;
    var toastText = atcToast.querySelector('.creator-reels__popup-atc-toast-text');
    if (toastText) toastText.textContent = message;
    atcToast.classList.toggle('is-error', !!isError);
    if (atcToastTimer) clearTimeout(atcToastTimer);
    requestAnimationFrame(function () {
      atcToast.classList.add('is-visible');
    });
    atcToastTimer = setTimeout(function () {
      atcToast.classList.remove('is-visible');
      atcToast.classList.remove('is-error');
    }, 2500);
  }

  function createCartPromise() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root) || '/', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (r) {
        return r.json();
      });
  }

  function onReelPopupAddComplete(ok, data) {
    if (!ok) {
      var msg = (data && (data.description || data.message)) || 'Could not add to cart';
      showAtcToast(msg, true);
      return;
    }
    showAtcToast('Product has been added to cart', false);
    createCartPromise()
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: { items: [data], cart: cart },
          })
        );
        document.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart },
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        syncMobileCartToolbarUI(cart.item_count);
      })
      .catch(function () {});
  }

  function reelPopupAddToCart(variantId, quantity) {
    var idNum = parseInt(variantId, 10);
    if (isNaN(idNum)) return;
    var qty = parseInt(quantity, 10) || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: idNum, quantity: qty }] }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        onReelPopupAddComplete(result.ok, result.data);
      })
      .catch(function () {
        showAtcToast('Could not add to cart', true);
      });
  }

  function updatePopupVideos() {
    var activeVideo = null;
    popupVideos.forEach(function (video, idx) {
      if (idx === popupIndex) {
        activeVideo = video;
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
    if (isScrollFeedMode) {
      applyProductForActiveReel();
    }
    try {
      document.dispatchEvent(
        new CustomEvent('creator-reels:popup-slide-change', {
          bubbles: true,
          detail: { index: popupIndex, video: activeVideo },
        })
      );
    } catch (err) {
      /* ignore */
    }
  }

  function refreshProductUiRefs() {
    if (!popup) return;
    popupDetails = popup.querySelector('.creator-reels__popup-details');
    atcBtn = popup.querySelector('.creator-reels__popup-atc-btn');
    popupTitle = popup.querySelector('.creator-reels__popup-title');
    variantStrip = popup.querySelector('.creator-reels__popup-variant-strip');
  }

  function syncPopupCartFromPage() {
    var countEl = document.querySelector('hdt-cart-count');
    var count = countEl ? parseInt(countEl.textContent, 10) : 0;
    if (isNaN(count)) count = 0;
    syncMobileCartToolbarUI(count);
  }

  function finalizeProductUi() {
    refreshProductUiRefs();
    syncReelPopupAtcFromVariant();
    syncPopupCartFromPage();
    if (variantStrip) {
      requestAnimationFrame(function () {
        scrollSelectedReelVariantIntoView(variantStrip);
      });
    }
    var openSelVid =
      atcBtn &&
      (atcBtn.getAttribute('data-selected-variant-id') ||
        atcBtn.getAttribute('data-default-variant-id') ||
        '');
    if (openSelVid) syncPageProductFormVariantId(String(openSelVid).trim());
    if (typeof window.reelVariantSaleTimerInit === 'function') {
      window.reelVariantSaleTimerInit();
    }
    if (popupTitle) {
      shareTitle = popupTitle.getAttribute('data-default-title') || shareTitle;
      if (popup) popup.setAttribute('data-share-title', shareTitle);
    }
  }

  function applyProductForKey(productKey) {
    if (!isScrollFeedMode || !popup) return;
    var key = productKey && String(productKey).trim() ? String(productKey).trim() : 'default';
    if (key === activeProductKey) return;

    var templates = document.querySelector('.creator-reels__popup-product-templates');
    if (!templates) return;

    var tpl =
      templates.querySelector('[data-reel-product-template="' + key.replace(/"/g, '') + '"]') ||
      templates.querySelector('[data-reel-product-template="default"]');
    if (!tpl) return;

    if (!popupDetails) popupDetails = popup.querySelector('.creator-reels__popup-details');
    if (!popupDetails) return;

    popupDetails.innerHTML = tpl.innerHTML;
    activeProductKey = tpl.getAttribute('data-reel-product-template') || key;
    finalizeProductUi();
  }

  function applyProductForActiveReel() {
    applyProductForKey(reelProductKeys[popupIndex] || 'default');
  }

  function updatePopupTransforms(delta) {
    if (isScrollFeedMode) return;
    var offset = delta || 0;
    popupVideos.forEach(function (video, idx) {
      video.style.transform =
        'translateY(' + ((idx - popupIndex) * window.innerHeight + offset) + 'px)';
    });
  }

  function teardownScrollFeedMode() {
    if (scrollFeedRaf) {
      cancelAnimationFrame(scrollFeedRaf);
      scrollFeedRaf = null;
    }
    isScrollFeedMode = false;
    if (popup) popup.removeAttribute('data-mode');
    if (slidesContainer) {
      slidesContainer.scrollTop = 0;
    }
  }

  function getScrollFeedIndex() {
    if (!slidesContainer || !popupVideos.length) return 0;
    var h = slidesContainer.clientHeight || window.innerHeight;
    if (!h) return 0;
    var idx = Math.round(slidesContainer.scrollTop / h);
    return Math.max(0, Math.min(popupVideos.length - 1, idx));
  }

  function onScrollFeedScroll() {
    if (!isScrollFeedMode) return;
    if (scrollFeedRaf) return;
    scrollFeedRaf = requestAnimationFrame(function () {
      scrollFeedRaf = null;
      var idx = getScrollFeedIndex();
      if (idx === popupIndex) return;
      popupIndex = idx;
      updatePopupVideos();
    });
  }

  function jumpToScrollFeedIndex(index) {
    if (!isScrollFeedMode || !slidesContainer || !popupVideos.length) return;
    var safeIndex = Math.max(0, Math.min(popupVideos.length - 1, Number(index) || 0));
    popupIndex = safeIndex;

    /* Disable snap briefly so the open lands exactly on the clicked reel */
    slidesContainer.style.scrollSnapType = 'none';
    var slideHeight = slidesContainer.clientHeight || window.innerHeight;
    var target = popupVideos[safeIndex];
    slidesContainer.scrollTop =
      target && target.offsetTop > 0 ? target.offsetTop : safeIndex * slideHeight;
    void slidesContainer.offsetHeight;
    slidesContainer.style.scrollSnapType = '';
  }

  function buildSlides(reelSources, startIndex) {
    popupIndex = typeof startIndex === 'number' ? startIndex : 0;
    if (popupIndex < 0) popupIndex = 0;
    if (popupIndex >= reelSources.length) popupIndex = reelSources.length - 1;

    slidesContainer.innerHTML = '';
    popupVideos = [];
    reelProductKeys = [];

    reelSources.forEach(function (source, idx) {
      var videoUrl = source.url || '';
      var thumb = source.thumbnail || '';
      if (!thumb && videoUrl && videoUrl.indexOf('#') === -1) {
        videoUrl = videoUrl + '#t=0.001';
      }
      var productKey = source.productKey && String(source.productKey).trim()
        ? String(source.productKey).trim()
        : 'default';
      reelProductKeys.push(productKey);

      var vid = document.createElement('video');
      vid.src = videoUrl;
      if (thumb) vid.poster = thumb;
      vid.loop = true;
      vid.playsInline = true;
      vid.muted = isMuted;
      vid.setAttribute('playsinline', '');
      vid.setAttribute('data-reel-index', String(idx));
      if (productKey !== 'default') vid.setAttribute('data-product-key', productKey);
      vid.className = 'creator-reels__popup-video';
      if (!isScrollFeedMode) {
        vid.style.transform = 'translateY(' + (idx - popupIndex) * 100 + 'vh)';
      }
      slidesContainer.appendChild(vid);
      popupVideos.push(vid);
    });
  }

  function closePopup() {
    if (atcToastTimer) clearTimeout(atcToastTimer);
    atcToastTimer = null;
    if (atcToast) atcToast.classList.remove('is-visible');
    popup.classList.remove('active');
    setTimeout(function () {
      popup.style.display = 'none';
      document.body.style.overflow = '';
      popupVideos.forEach(function (v) {
        v.pause();
      });
      teardownScrollFeedMode();
      activeProductKey = null;
      reelProductKeys = [];
      if (activeContext && typeof activeContext.onClose === 'function') {
        activeContext.onClose();
      }
      activeContext = null;
    }, 300);
  }

  function openPopup(reelSources, index, context) {
    if (!popup || !reelSources || !reelSources.length) return;
    activeContext = context || null;
    if (activeContext && typeof activeContext.beforeOpen === 'function') {
      activeContext.beforeOpen();
    }

    /* Scroll-feed is opt-in for creator-reels PDP only; PLP keeps transform swipe */
    isScrollFeedMode = !!(
      activeContext &&
      activeContext.scrollFeed &&
      popup.getAttribute('data-scroll-feed') === 'true'
    );
    if (isScrollFeedMode) {
      popup.setAttribute('data-mode', 'scroll-feed');
    } else {
      teardownScrollFeedMode();
    }

    popup.style.display = 'block';
    document.body.style.overflow = 'hidden';
    activeProductKey = null;
    buildSlides(reelSources, index);

    if (isScrollFeedMode) {
      jumpToScrollFeedIndex(popupIndex);
      applyProductForActiveReel();
    }

    requestAnimationFrame(function () {
      if (isScrollFeedMode) {
        jumpToScrollFeedIndex(popupIndex);
      }
      popup.classList.add('active');
      setTimeout(function () {
        if (isScrollFeedMode) {
          jumpToScrollFeedIndex(popupIndex);
          applyProductForActiveReel();
        }
        updatePopupVideos();
        if (!isScrollFeedMode) {
          syncReelPopupAtcFromVariant();
          if (variantStrip) {
            requestAnimationFrame(function () {
              scrollSelectedReelVariantIntoView(variantStrip);
            });
          }
          var openSelVid =
            atcBtn &&
            (atcBtn.getAttribute('data-selected-variant-id') ||
              atcBtn.getAttribute('data-default-variant-id') ||
              '');
          if (openSelVid) syncPageProductFormVariantId(openSelVid.trim());
          if (typeof window.reelVariantSaleTimerInit === 'function') {
            window.reelVariantSaleTimerInit();
          }
        }
      }, 50);
    });
  }

  function getReelSourcesFromPdp(root, index) {
    var panel = root.querySelector('.creator-reels__panel:not([hidden])');
    var wrappers = panel ? panel.querySelectorAll('.creator-reels__video-wrapper') : [];
    var sources = [];
    wrappers.forEach(function (wrapper) {
      var container = wrapper.querySelector('.creator-reels__video-container');
      if (!container) return;
      sources.push({
        url: container.getAttribute('data-video-url') || '',
        thumbnail: container.getAttribute('data-video-thumbnail') || '',
        productKey: container.getAttribute('data-product-key') || 'default',
      });
    });
    return { sources: sources, index: index };
  }

  function getReelSourcesFromPlp(root) {
    var reelsData = root.querySelector('.plp-product-video__reels-data');
    if (!reelsData) return { sources: [], index: 0 };
    var items = reelsData.querySelectorAll('.plp-product-video__reel-item');
    var sources = [];
    items.forEach(function (item) {
      sources.push({
        url: item.getAttribute('data-video-url') || '',
        thumbnail: item.getAttribute('data-video-thumbnail') || '',
      });
    });
    return { sources: sources, index: 0 };
  }

  function initPopupBindings() {
    if (initialized || !popup) return;
    initialized = true;

    shareTitle = popup.getAttribute('data-share-title') || '';
    slidesContainer = popup.querySelector('.creator-reels__popup-slides');
    atcToast = popup.querySelector('.creator-reels__popup-atc-toast');
    refreshProductUiRefs();

    var closeBtn = popup.querySelector('.creator-reels__popup-close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    /* Delegated so product swaps (creator-reels scroll-feed) keep working */
    popup.addEventListener(
      'click',
      function (e) {
        var variantBtn = e.target.closest('button.reel-v-btn');
        if (variantBtn && popup.contains(variantBtn)) {
          var strip = variantBtn.closest('.creator-reels__popup-variant-strip');
          if (strip) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var wrap = variantBtn.closest('.reel-v-wrap');
            if (!wrap || wrap.classList.contains('reel-v-wrap--oos')) return;
            strip.querySelectorAll('.reel-v-wrap').forEach(function (el) {
              el.classList.remove('is-selected');
              var innerBtn = el.querySelector('button.reel-v-btn');
              if (innerBtn) innerBtn.classList.remove('is-selected');
            });
            wrap.classList.add('is-selected');
            variantBtn.classList.add('is-selected');
            refreshProductUiRefs();
            requestAnimationFrame(function () {
              scrollSelectedReelVariantIntoView(strip);
            });
            var vid = variantBtn.getAttribute('data-variant-id');
            syncReelPopupAtcFromVariant();
            syncPageProductFormVariantId(vid);
            return;
          }
        }

        var cartBtn = e.target.closest('.creator-reels__popup-cart .hdt-toolbar-item-btn');
        if (cartBtn && popup.contains(cartBtn)) {
          document.body.style.overflow = '';
          closePopup();
          return;
        }

        var clickedAtc = e.target.closest('.creator-reels__popup-atc-btn');
        if (clickedAtc && popup.contains(clickedAtc)) {
          refreshProductUiRefs();
          var selectedVid = (
            clickedAtc.getAttribute('data-selected-variant-id') ||
            clickedAtc.getAttribute('data-default-variant-id') ||
            ''
          ).trim();
          if (selectedVid) {
            reelPopupAddToCart(selectedVid, 1);
            return;
          }
          var form = document.querySelector('form[action*="/cart/add"]');
          if (!form) return;
          var formData = new FormData(form);
          var formVariantId = formData.get('id');
          var formQty = parseInt(formData.get('quantity') || '1', 10) || 1;
          if (formVariantId) {
            reelPopupAddToCart(formVariantId, formQty);
            return;
          }
          fetch('/cart/add.js', { method: 'POST', body: formData })
            .then(function (r) {
              return r.json().then(function (data) {
                return { ok: r.ok, data: data };
              });
            })
            .then(function (result) {
              onReelPopupAddComplete(result.ok, result.data);
            })
            .catch(function () {
              showAtcToast('Could not add to cart', true);
            });
        }
      },
      true
    );

    /* PLP-only transform swipe — skipped when creator-reels scroll-feed is active */
    slidesContainer.addEventListener(
      'touchstart',
      function (e) {
        if (isScrollFeedMode) return;
        touchStartY = e.touches[0].clientY;
        touchDeltaY = 0;
        isSwiping = true;
      },
      { passive: true }
    );

    slidesContainer.addEventListener(
      'touchmove',
      function (e) {
        if (isScrollFeedMode || !isSwiping) return;
        touchDeltaY = e.touches[0].clientY - touchStartY;
        updatePopupTransforms(touchDeltaY);
      },
      { passive: true }
    );

    slidesContainer.addEventListener('touchend', function () {
      if (isScrollFeedMode || !isSwiping) return;
      isSwiping = false;
      var threshold = 80;
      if (touchDeltaY < -threshold && popupIndex < popupVideos.length - 1) {
        popupIndex++;
      } else if (touchDeltaY > threshold && popupIndex > 0) {
        popupIndex--;
      }
      touchDeltaY = 0;
      updatePopupTransforms();
      updatePopupVideos();
    });

    if (!scrollFeedBound) {
      scrollFeedBound = true;
      slidesContainer.addEventListener('scroll', onScrollFeedScroll, { passive: true });
    }

    slidesContainer.addEventListener('click', function () {
      var video = popupVideos[popupIndex];
      if (!video) return;
      video.paused ? video.play().catch(function () {}) : video.pause();
    });

    popup.querySelectorAll('.creator-reels__popup-icon-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var action = item.getAttribute('data-action');
        if (action === 'whatsapp') {
          var msg = encodeURIComponent(
            'Just saw this on Aqualogica and immediately thought of you. Check it out – super relatable! ' +
              window.location.href
          );
          window.open('https://api.whatsapp.com/send?text=' + msg, '_blank');
        } else if (action === 'share') {
          if (navigator.share) {
            navigator
              .share({ title: shareTitle || document.title, url: window.location.href })
              .catch(function () {});
          }
        } else if (action === 'mute') {
          isMuted = !isMuted;
          popupVideos.forEach(function (v) {
            v.muted = isMuted;
          });
          var label = item.querySelector('.creator-reels__popup-icon-label');
          var iconWrap = item.querySelector('[data-mute-icon]');
          if (label) label.textContent = isMuted ? 'Unmute' : 'Mute';
          if (iconWrap) {
            iconWrap.innerHTML = isMuted
              ? '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z" stroke="white" stroke-width="1.6" stroke-linejoin="round"/><path d="m16 9 5 5M21 9l-5 5" stroke="white" stroke-width="1.6" stroke-linecap="round"/></svg>'
              : '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z" stroke="white" stroke-width="1.6" stroke-linejoin="round"/><path d="M15.5 8.5a5 5 0 0 1 0 7" stroke="white" stroke-width="1.6" stroke-linecap="round"/><path d="M18 6a8.5 8.5 0 0 1 0 12" stroke="white" stroke-width="1.6" stroke-linecap="round"/></svg>';
          }
        }
      });
    });

    document.addEventListener('cart:change', function (e) {
      var itemCount = e && e.detail && e.detail.cart && e.detail.cart.item_count;
      if (itemCount != null) syncMobileCartToolbarUI(itemCount);
    });
  }

  function initPlpRoots() {
    document.querySelectorAll('[data-plp-product-video-root]').forEach(function (root) {
      if (root.dataset.plpReelInit === 'true') return;
      root.dataset.plpReelInit = 'true';

      var previewVideo = root.querySelector('video.hdt-plp-product-video__media');

      function pausePreviewVideo() {
        if (previewVideo && previewVideo.tagName === 'VIDEO' && !previewVideo.paused) {
          previewVideo.pause();
        }
      }

      function resumePreviewVideo() {
        if (previewVideo && previewVideo.tagName === 'VIDEO' && previewVideo.paused) {
          previewVideo.play().catch(function () {});
        }
      }

      function handleOpen(e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        if (e.type === 'keydown') e.preventDefault();
        var trigger = e.target.closest('[data-plp-reel-open]');
        if (!trigger || !root.contains(trigger)) return;
        e.preventDefault();
        e.stopPropagation();

        var data = getReelSourcesFromPlp(root);
        if (!data.sources.length) return;

        openPopup(data.sources, data.index, {
          type: 'plp',
          scrollFeed: false,
          beforeOpen: pausePreviewVideo,
          onClose: resumePreviewVideo,
        });
      }

      root.addEventListener('click', handleOpen);
      root.addEventListener('keydown', handleOpen);
    });
  }

  function boot() {
    popup = document.getElementById('creatorReelsPopup');
    if (!popup) return;
    initPopupBindings();
    initPlpRoots();
  }

  window.CreatorReelPopup = {
    openFromPdp: function (root, index, hooks) {
      if (!popup) popup = document.getElementById('creatorReelsPopup');
      if (!popup) return;
      initPopupBindings();
      if (isDesktop()) return;
      var data = getReelSourcesFromPdp(root, index);
      if (!data.sources.length) return;
      openPopup(data.sources, data.index, {
        type: 'pdp',
        scrollFeed: popup.getAttribute('data-scroll-feed') === 'true',
        beforeOpen: hooks && hooks.beforeOpen,
        onClose: hooks && hooks.onClose,
      });
    },
    close: closePopup,
  };

  window.openCreatorReelsPopup = function (index) {
    var root = document.querySelector('[data-creator-reels]');
    if (!root) return;
    window.CreatorReelPopup.openFromPdp(root, typeof index === 'number' && index >= 0 ? index : 0, window.__creatorReelsPopupHooks || {});
  };

  if (!window.reelVariantSaleTimerInit) {
    window.reelVariantSaleTimerInit = function () {
      var timers = document.querySelectorAll('.section-creator-reels .reel-v-ribbon .variant-sale-timer');
      timers.forEach(function (timer) {
        if (timer.dataset.timerActive === 'true') return;
        var timerSpan = timer.querySelector('span[data-sale-timestamp]');
        if (!timerSpan) return;
        var saleTimestamp = parseInt(timerSpan.getAttribute('data-sale-timestamp'), 10) * 1000;
        if (isNaN(saleTimestamp) || saleTimestamp <= 0 || saleTimestamp <= Date.now()) {
          timer.style.display = 'none';
          return;
        }
        timer.dataset.timerActive = 'true';
        function updateTimer() {
          var distance = saleTimestamp - Date.now();
          if (distance <= 0) {
            timer.style.display = 'none';
            timer.dataset.timerActive = 'false';
            return false;
          }
          var totalHours = Math.floor(distance / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          timerSpan.textContent = totalHours + 'h : ' + minutes + 'm : ' + seconds + 's';
          return true;
        }
        if (updateTimer()) {
          setInterval(updateTimer, 1000);
        }
      });
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    boot();
    initPlpRoots();
  });
})();
